<template>
  <div>
    <!-- Buttons -->
    <v-btn @click="printDoorSign">Print Door sign</v-btn><v-btn @click="printGuestHandouts">Print Guest Handouts</v-btn><v-btn @click="printWorkstationSigns">Print Workstation Markers</v-btn>

    <v-dialog
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
      v-model="printPreview"
    >
      <v-card>
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click.native="printPreview = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Print Preview</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click.native="printPreview = false">Save PDF</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text style="height: 100%;">
          <div style="width: 100%; height: 100%" id="iframeContainer"></div>
        </v-card-text>
        <v-card-actions v-if="previewType == 'doorSign'">
          <v-checkbox class="ml-5" v-model="doorSignTitle" @change="printDoorSign" label="Show event title"></v-checkbox>
        </v-card-actions>
        <v-card-actions v-if="previewType == 'guestHandouts' || previewType == 'workstations'">
          <div>
            Wifi Info:
          </div>
          <br>
          <v-text-field v-model="wifiName" placeholder="Wifi Network"></v-text-field>
          <v-text-field v-model="wifiPassword" placeholder="Wifi Password"></v-text-field>
          <v-btn color="info" @click="() => { previewType == 'workstations' ? printWorkstationSigns() : printGuestHandouts() }">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import printjs from 'print-js'

import pdfMake from "pdfmake/build/pdfmake";
// import pdfFonts from "pdfmake/build/vfs_fonts";
import pdfFonts from "~/assets/fonts/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

import { replaceNewlines } from '~/store/util/util'
import { pngLogo } from '~/assets/images/logo-png-data'
export default {
  name: 'host-marketing-materials',
  props: ['event'],
  data () {
    return {
      doorSignTitle: true,
      printPreview: false,
      previewType: null,
      printFoldable: true,
      printPage: null,
      wifiName: '',
      wifiPassword: ''
    }
  },
  methods: {
    printPdf (htmlId) {
      // alert('door sign')
      // printjs('print-door-sign', 'html')
      printjs({ printable: htmlId, type: 'html', maxWidth: 950, targetStyles: ['*'] })
    },
    printDoorSign () {
      this.printPreview = true
      this.previewType = 'doorSign'
      var docDefinition = {
        info: {
          title: this.event.title + ' Door Sign',
          author: this.event.host.user.first_name + ' ' + this.event.host.user.last_name,
          subject: this.event.title,
          keywords: 'wrkprty,event,coworking,' + this.event.title,
        },
        content: [
          {
            image: pngLogo,
            width: 200,
            alignment: 'center',
            margin: [0, 10, 0, 30]
          },
          {
            text: 'WRKPRTY',
            fontSize: 60,
            alignment: 'center',
            margin: [0, 0, 0, 10],
            font: 'Quantico'
          },
          {
            text: 'wrkprty.com',
            fontSize: 35,
            alignment: 'center',
            font: 'Quantico'
          }
        ]
      }
      if (this.doorSignTitle) {
        docDefinition.content.splice(2, 0, {
          text: this.event.title,
          fontSize: 35,
          alignment: 'center',
          margin: [0, 0, 0, 10],
          font: 'Quantico'
        })
        docDefinition.content[3].fontSize = 25
      }
      pdfMake.fonts = {
        Quantico: {
          normal: 'Quantico'
        },
        Verdana: {
          normal: 'Verdana'
        }
      }
      const pdfDocGenerator = pdfMake.createPdf(docDefinition);
      pdfDocGenerator.getDataUrl((dataUrl) => {
        const targetElement = document.querySelector('#iframeContainer');
        const iframe = document.createElement('iframe');
        iframe.style = 'width: 100%; height: 100%;'
        iframe.src = dataUrl;
        targetElement.innerHTML = ''
        targetElement.appendChild(iframe);
      });
      // pdfMake.createPdf(docDefinition).download();
    },
    printWorkstationSigns () {
      // <h4 class="mb-4">Welcome, {{ attendee.first_name }} {{ attendee.last_name }}!</h4>
      // <p class="mb-2">{{ event.title }}</p>
      // <p class="mb-2">{{ event.subtitle }}</p>
      // <p class="mb-3">{{ event.date }}</p>
      this.printPreview = true
      this.previewType = 'workstations'
      let guestCards = []
      let result
      for (let i=0; i<this.event.max_attendees; i++) {
        result = []
        result.push({
          image: pngLogo,
          width: 130,
          alignment: 'center',
          margin: [0, 20, 0, 15]
        })
        result.push({
          text: 'WORKSTATION',
          fontSize: 35,
          alignment: 'center',
          margin: [0, 0, 0, 5],
          font: 'Quantico'
        })
        result.push({
          text: 'wrk station ;)',
          fontSize: 18,
          font: 'Quantico'
        })
        let wifi = {
          margin: [0, 30, 0, 20],
          columns: [
            [
              {
                text: 'Info',
                font: 'Quantico',
                fontSize: 16,
                margin: [0,0,0,15]
              },
              {
                text: this.event.subtitle,
                font: 'Verdana',
                margin: [0,0,0,10]
              }
              // {
              //   text: 'Visit this webpage to join this wrkprty chatroom and view the active schedule!',
              //   font: 'Verdana',
              //   margin: [0,0,0,10]
              // },
              // {
              //   text: `wrkprty.com/active-event/${this.event.slug}`,
              //   style: 'url',
              //   font: 'Verdana'
              // }
            ],
            [
              {
                text: 'Wifi',
                font: 'Quantico',
                fontSize: 16,
                margin: [0,0,0,15]
              },
              {
                text: 'Network Name',
                font: 'Verdana',
                margin: [0,0,0,5]
              },
              {
                text: this.wifiName,
                font: 'Verdana',
                margin: [0, 0, 0, 10]
              },
              {
                text: 'Password',
                font: 'Verdana',
                margin: [0,0,0,5]
              },
              {
                text: this.wifiPassword,
                font: 'Verdana',
              }
            ]
          ]
        }
        if ((i !== Math.ceil(this.event.max_attendees/2) - 1) && (i !== this.event.max_attendees - 1)) {
          wifi['pageBreak'] = 'after'
        }
        result.push(wifi)
        guestCards.push(result)
      }
      let content = {
        columns: [
          [...guestCards.slice(0, Math.ceil(guestCards.length/2))],
          [...guestCards.slice(Math.ceil(guestCards.length/2))],
        ]
      }
      var docDefinition = {
        pageOrientation: 'landscape',
        info: {
          title: this.event.title + ' Guest Handouts',
          author: this.event.host.user.first_name + ' ' + this.event.host.user.last_name,
          subject: this.event.title,
          keywords: 'wrkprty,event,coworking,' + this.event.title,
        },
        content: content,
        styles: {
          url: {
            color: '#67a3bb',
            decoration: 'underline'
          }
        },
        defaultStyle: {
          columnGap: 20,
          alignment: 'center'
        }
      }
      pdfMake.fonts = {
        Quantico: {
          normal: 'Quantico'
        },
        Verdana: {
          normal: 'Verdana'
        }
      }
      const pdfDocGenerator = pdfMake.createPdf(docDefinition);
      pdfDocGenerator.getDataUrl((dataUrl) => {
        const targetElement = document.querySelector('#iframeContainer');
        const iframe = document.createElement('iframe');
        iframe.style = 'width: 100%; height: 100%;'
        iframe.src = dataUrl;
        targetElement.innerHTML = ''
        targetElement.appendChild(iframe);
      });
      // pdfMake.createPdf(docDefinition).download();
    },
    printGuestHandouts () {
      // <h4 class="mb-4">Welcome, {{ attendee.first_name }} {{ attendee.last_name }}!</h4>
      // <p class="mb-2">{{ event.title }}</p>
      // <p class="mb-2">{{ event.subtitle }}</p>
      // <p class="mb-3">{{ event.date }}</p>
      this.printPreview = true
      this.previewType = 'guestHandouts'
      let guestCards = this.event.attendees.map((guest, index, guests) => {
        let result = []
        result.push({
          image: pngLogo,
          width: 130,
          alignment: 'center',
          margin: [0, 20, 0, 15]
        })
        result.push({
          text: 'WRKPRTY',
          fontSize: 35,
          alignment: 'center',
          margin: [0, 0, 0, 5],
          font: 'Quantico'
        })
        result.push({
          text: this.event.title,
          fontSize: 16,
          font: 'Quantico'
        })
        result.push({
          text: this.event.date,
          font: 'Quantico'
        })
        result.push({
          text: `Welcome, ${guest.first_name} ${guest.last_name}!`,
          font: 'Verdana',
          margin: [0, 10, 0, 10]
        })
        result.push({
          text: 'Info',
          fontSize: 20,
          font: 'Quantico'
        })
        // result.push({
        //   text: 'Visit this URL to join the event chatroom and view the schedule!',
        //   font: 'Verdana',
        //   margin: [0, 10, 0, 10]
        // })
        result.push({
          text: this.event.subtitle,
          font: 'Verdana',
          margin: [0, 10, 0, 10]
        })
        // result.push({
        //   text: `wrkprty.com/active-event/${this.event.slug}`,
        //   style: 'url',
        //   font: 'Verdana'
        // })
        let wifi = {
          margin: [0, 10, 0, 20],
          columns: [
            [
              {
                text: 'wifi',
                font: 'Quantico'
              },
              {
                text: 'password',
                font: 'Quantico'
              }
            ],
            [
              {
                text: this.wifiName,
                font: 'Quantico'
              },
              {
                text: this.wifiPassword,
                font: 'Quantico',
              }
            ]
          ]
        }
        if ((index !== Math.ceil(guests.length/2) - 1) && (index !== guests.length - 1)) {
          wifi['pageBreak'] = 'after'
        }
        result.push(wifi)
        return result
      })
      let content = {
        columns: [
          [...guestCards.slice(0, Math.ceil(guestCards.length/2))],
          [...guestCards.slice(Math.ceil(guestCards.length/2))],
        ]
      }
      var docDefinition = {
        pageOrientation: 'landscape',
        info: {
          title: this.event.title + ' Guest Handouts',
          author: this.event.host.user.first_name + ' ' + this.event.host.user.last_name,
          subject: this.event.title,
          keywords: 'wrkprty,event,coworking,' + this.event.title,
        },
        content: content,
        styles: {
          url: {
            color: '#67a3bb',
            decoration: 'underline'
          }
        },
        defaultStyle: {
          columnGap: 20,
          alignment: 'center'
        }
      }
      pdfMake.fonts = {
        Quantico: {
          normal: 'Quantico'
        },
        Verdana: {
          normal: 'Verdana'
        }
      }
      const pdfDocGenerator = pdfMake.createPdf(docDefinition);
      pdfDocGenerator.getDataUrl((dataUrl) => {
        const targetElement = document.querySelector('#iframeContainer');
        const iframe = document.createElement('iframe');
        iframe.style = 'width: 100%; height: 100%;'
        iframe.src = dataUrl;
        targetElement.innerHTML = ''
        targetElement.appendChild(iframe);
      });
      // pdfMake.createPdf(docDefinition).download();
    },
    newlines(value) {
			return replaceNewlines(value)
		},
  }
}
</script>

<style>
.upside-down {
  -moz-transform: scale(-1, -1);
  -webkit-transform: scale(-1, -1);
  -o-transform: scale(-1, -1);
  -ms-transform: scale(-1, -1);
  transform: scale(-1, -1);
}
</style>
